import { ERROR_CODES } from '../constants/errors'

class AppError extends Error {
  constructor(
    message = '',
    statusCode = 998,
    code = ERROR_CODES.UNKNOWN_ERROR,
    metadata = {},
  ) {
    super('')
    this.name = this.constructor.name
    this.statusCode = statusCode ?? 998
    this.code = code ?? ERROR_CODES.UNKNOWN_ERROR
    this.metadata = metadata

    this._baseMessage = message
    this._updateFullMessage()

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    }
  }

  _updateFullMessage() {
    const metaStr = JSON.stringify(this.metadata)
    super.message = `${this._baseMessage} | code=${this.code} | statusCode=${this.statusCode} | metadata=${metaStr}`
  }

  get message() {
    return super.message
  }

  set message(val) {
    this._baseMessage = val
    this._updateFullMessage()
  }

  setMetadata(metadata) {
    this.metadata = metadata
    this._updateFullMessage()
    return this
  }

  setStatusCode(statusCode) {
    this.statusCode = statusCode
    this._updateFullMessage()
    return this
  }

  setCode(code) {
    this.code = code
    this._updateFullMessage()
    return this
  }

  toJSON() {
    return {
      message: this._baseMessage,
      code: this.code,
      statusCode: this.statusCode,
      metadata: this.metadata,
    }
  }
}

export default AppError
